/**
 * External dependencies
 */

import React from 'react';

/**
 * DWT dependencies
 */

import { authorShapeIcon } from '../.././img/icons';
import {
  handleContributorAuthorRoles,
  handleContributorImage,
  handleContributorTabAuthorRoles,
  decodeHtmlEntities,
} from '../utils/component-utils';

/**
 * ContributorModalMain
 *
 * Contributor main content for modal
 *
 * @param {Object}  props
 * @param {Object}  props.context
 * @param {Object}  props.modalData
 */
const ContributorModalMain = ({ context, modalData }) => {
  const handleContributorDescription = ( item ) => {
    if ( item?.spotlight === 'null' ) return false;
    return decodeURIComponent( item?.spotlight );
  };
  const handleContributorTabDescription = ( item ) => decodeURIComponent( item?.authorBio );

  const authorInitials =
        ( modalData?.firstInitial ?? '' ) + ( modalData?.lastInitial ?? '' );
  const getCoverImage = handleContributorImage( modalData );
  let getAuthorRoles = null;
  if ( modalData.contribRoles ) {
    getAuthorRoles = handleContributorAuthorRoles( modalData, context );
  } else if ( modalData.roles ) {
    getAuthorRoles = handleContributorTabAuthorRoles( modalData );
  } else if ( modalData.authorRoles ) {
    getAuthorRoles = modalData.authorRoles.join( ', ' );
  }
  const getDescription = modalData.spotlight
    ? handleContributorDescription( modalData )
    : handleContributorTabDescription( modalData );
  const getReadMoreURL = modalData?.authorId
    ? `https://penguinrandomhouse.com/authors/${modalData.authorId}`
    : false;

  return (
    <>
      <div className="modal__main">
        <div className="modal__details-view">
          <div className="modal__cover">
            <div className="image-wrapper relative flex flex-col">
              <img
                className="api-image"
                src={getCoverImage}
                alt={
                  modalData?.display
                    ? modalData.display
                    : null
                }
                data-author-id={modalData?.authorId ?? null}
                title={modalData?.display ?? null}
                loading="lazy"
              />
              {modalData?.photocredit &&
                                modalData?.hasAuthorPhoto && (
                <p className="mt-5 text-10 leading-normal ml-0">
                                        Photo: &copy;{modalData.photocredit}
                </p>
              )}
              {!modalData?.hasAuthorPhoto && (
                <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                  {authorShapeIcon}
                  <span className="heading-1 absolute left-1/2 top-1/2 m-0 -translate-x-1/2 -translate-y-1/2">
                    {authorInitials}
                  </span>
                </div>
              )}
            </div>
          </div>

          <div className="modal__details justify-center md:flex md:basis-3/5 md:flex-col">
            {getAuthorRoles && (
              <h3 className="modal__roles paragraph-3 mx-0 mb-17 mt-0 font-700 uppercase">
                <span
                  dangerouslySetInnerHTML={{
                    __html: getAuthorRoles
                  }}
                />
              </h3>
            )}

            {modalData?.display && (
              <h3 className="modal__heading heading-3 mx-0 mb-0 mt-0">
                <span
                  dangerouslySetInnerHTML={{
                    __html: decodeURIComponent( modalData.display )
                  }}
                />
              </h3>
            )}

            {getDescription && (
              <p className="modal__description paragraph-2 font-200">
                <span
                  dangerouslySetInnerHTML={{
                    __html: getDescription
                  }}
                ></span>
                {getReadMoreURL && (
                  <a
                    href={getReadMoreURL}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Read more about ${decodeHtmlEntities( decodeURIComponent( modalData.display ) )}`}
                  >
                    <strong>Read more&nbsp;&#62;</strong>
                  </a>
                )}
              </p>
            )}
          </div>
        </div>
      </div>
      <div className="modal__footer">
        {getReadMoreURL && (
          <a
            className="modal__footer-link"
            href={getReadMoreURL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`View Full Details for ${decodeHtmlEntities( decodeURIComponent( modalData.display ) )}`}
          >
            <strong>View Full Details &#10141;</strong>
          </a>
        )}
      </div>
    </>
  );
};

export default ContributorModalMain;
